module.exports = __webpack_public_path__ + "img/tab_bg.805a2131.png";